import { atom } from "recoil";
import { keysOfRecoil } from "../keys";
export const introStepState = atom<number>({
  key: keysOfRecoil.INTRO_STEP,
  default: 1,
});
